
'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { FiFacebook, FiLinkedin } from 'react-icons/fi';
import { FaXTwitter, FaInstagram } from 'react-icons/fa6';
import { TbBrandYoutube } from 'react-icons/tb';
import { motion } from 'framer-motion';
import Button from './Button';
import logo from '@/../public/LOGO 2.svg';
import { BsMailbox } from 'react-icons/bs';
import { MdOutlineEmail } from 'react-icons/md';

const Footer = () => {
  const [firstName, setFirstName] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleSubmit = async () => {
    if (!firstName || !email) {
      setMessage('Please fill in both fields');
      return;
    }

    setLoading(true);
    setMessage('');

    try {
      const res = await fetch('', {
        method: 'POST',
        body: JSON.stringify({firstName, email }),
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (res.ok) {
        setMessage('🎉 Subscription successful!');
        setFirstName('');
        setEmail('');
      } else {
        setMessage('Something went wrong. Please try again.');
      }
    } catch (error) {
      console.error('Error:', error);
      setMessage('Error submitting form.');
    }

    setLoading(false);
  };

  return (
    <motion.footer
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: 'easeOut' }}
      viewport={{ once: false }}
      className="bg-neutral-800 py-10"
    >
      <div className="container mx-auto px-4 lg:px-12 grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7 lg:gap-32">
        <div className="text-center md:text-left max-w-sm">
          <Image src={logo} alt="MashonaDev Logo" width={150} height={40} className="mb-3" />
          <p className="text-sm text-gray-400 leading-relaxed w-[292.14px]">
            MashonaDev is an outsourcing company that connects businesses with skilled developers while providing passive income opportunities and internship programs for undergraduates.
          </p>
        </div>

        <div className="text-left">
          <h4 className="font-semibold lg:font-bold mb-4">Company</h4>
          <div className="flex flex-col md:flex-row lg:flex-row space-y-4 lg:space-x-4 text-sm text-gray-500">
            <Link href="/" className="hover:text-orange-500">Home</Link>
            <Link href="/services" className="hover:text-orange-500">Services</Link>
            <Link href="/careers" className="hover:text-orange-500">Careers</Link>
            {/* <Link href="/portfolio" className="hover:text-orange-500">Portfolio</Link> */}
            <Link href="/about-us" className="hover:text-orange-500">About Us</Link>
          </div>
        </div>
      </div>

      <div className="container mx-auto my-8 px-4 py-6 lg:px-12 lg:py-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8 border-t border-b border-gray-600">
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: false }}
        >
          <div className="text-left">
            <div className="flex flex-col space-y-6">
              <div className="flex flex-col lg:flex-row lg:space-x-5">
                <div className="mb-4">
                  <h4 className="font-bold mb-2">First Name</h4>
                  <input
                    type="text"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    placeholder="First Name"
                    className="bg-neutral-700 text-neutral-400 px-4 py-2 rounded-md w-full border border-neutral-600"
                  />
                </div>

                <div>
                  <p className="font-bold mb-2">Email</p>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="user@example.com"
                    className="bg-neutral-700 text-neutral-400 px-4 py-2 rounded-md w-full border border-neutral-600"
                  />
                </div>
              </div>
              <Button
                className="w-full lg:w-1/2"
                onClick={handleSubmit}
                disabled={loading}
              >
                {loading ? 'Subscribing...' : 'Subscribe to Newsletter'}
              </Button>
              {message && <p className="text-sm mt-2 text-orange-400">{message}</p>}
            </div>
          </div>
        </motion.div>

        <div className="flex items-center justify-evenly md:justify-evenly lg:justify-end space-x-6">
          <motion.a whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.95 }} href="https://web.facebook.com/profile.php?id=61575109525387" target="_blank" rel="noopener noreferrer" className="bg-orange-100 p-3 rounded-full text-black shadow-md hover:bg-orange-200">
            <FiFacebook className="text-xl" />
          </motion.a>
          <motion.a whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.95 }} href="https://x.com/mashonadev?s=21" target="_blank" rel="noopener noreferrer" className="bg-orange-100 p-3 rounded-full text-black shadow-md hover:bg-orange-200">
            <FaXTwitter className="text-xl" />
          </motion.a>
          <motion.a whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.95 }} href=" https://www.linkedin.com/company/mashonadev/" target="_blank" rel="noopener noreferrer" className="bg-orange-100 p-3 rounded-full text-black shadow-md hover:bg-orange-200">
            <FiLinkedin className="text-xl" />
          </motion.a>
          <motion.a whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.95 }} href=" https://www.instagram.com/mashonadev?igsh=MTR3YjE3dDZ4cXgwZg%3D%3D&utm_source=qr " target="_blank" rel="noopener noreferrer" className="bg-orange-100 p-3 rounded-full text-black shadow-md hover:bg-orange-200">
            <FaInstagram className="text-xl" />
          </motion.a>
            <motion.a whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.95 }} href="mailto:mashonadevs@gmail.com" target="_blank" rel="noopener noreferrer" className="bg-orange-100 p-3 rounded-full text-black shadow-md hover:bg-orange-200">
            <MdOutlineEmail className="text-xl" />
            </motion.a>
        </div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.4, duration: 0.6 }}
        viewport={{ once: false }}
        className="container mx-auto px-12 text-gray-500 text-sm mt-8 text-center md:text-left"
      >
        &copy; {new Date().getFullYear()} MashonaDev. All Rights Reserved.
      </motion.div>
    </motion.footer>
  );
};

export default Footer;
